import { render, staticRenderFns } from "./DangerButton.vue?vue&type=template&id=6d4c97a9&"
import script from "./DangerButton.vue?vue&type=script&lang=js&"
export * from "./DangerButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports